module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_vaxjo-62ea2f4f24556d0822783ae5cd4b8a28.png";